import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    productSpecs: {
      type: Array,
      default: () => [],
    },
    productSpecsHeadings: {
      type: Array,
      default: () => [],
    },
    productFeatures: {
      type: String,
      default: null,
    },
    isSos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  methods: {
    // e is the value of $event
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setTabIndex(e: any) {
        this.selectedTab = e.target.getAttribute('index');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    showTableColumnValue(rowIndex: number, tableColumn: any) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this.productSpecs[rowIndex].filter((item: any) => item.label === tableColumn).length > 0;
    },
  },
  template: '#t-product-tabs',
});
